import { render, staticRenderFns } from "./SmplEditBomChild.vue?vue&type=template&id=4aaee2e5&scoped=true&"
import script from "./SmplEditBomChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditBomChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaee2e5",
  null
  
)

export default component.exports